export const APP_IMAGES = {
  playIcon: require("./play_icon.png"),
  logoWebinar: require("./logo_webbanner.png"),
};
